import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import MarketingLayout from './shared/MarketingLayout';
import { PageHero, Section, SectionHeader, FeatureCard, CTAStrip } from './shared/blocks';
import SEO from './shared/SEO';
import { Button } from '../../components/ui/button';
import { AI_TOOLS, ERP_MODULES } from './content';

export default function FeaturesPage() {
  return (
    <MarketingLayout>
      <SEO
        title="Features | AI tools for teachers + School ERP"
        description="Browse the ActanonEdu toolkit — six AI content generators (lesson plans, worksheets, quizzes, question papers, assignments, teaching materials) plus six School ERP modules (attendance, fees, communication, records, academics, administration)."
        path="/features"
        keywords={['ActanonEdu features', 'AI tools for teachers', 'school ERP modules', 'teacher productivity']}
        breadcrumbs={[{ name: 'Home', url: '/' }, { name: 'Features', url: '/features' }]}
      />
      <PageHero
        eyebrow="Features"
        title="Everything in ActanonEdu —"
        accent="all in one place."
        subtitle="An AI tool for teachers, a multilingual content engine, and a full School ERP. Browse the toolkit; each card links to a deeper dive."
        testid="features-hero"
      />

      <Section tone="muted">
        <SectionHeader eyebrow="Content generation" title="The AI Tools" subtitle="Six teacher-facing generators — each board-aware, multilingual, and download-ready." />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {AI_TOOLS.map((tool) => (
            <Link key={tool.id} to="/ai-tools-for-teachers" className="block group">
              <FeatureCard
                icon={tool.icon}
                name={tool.name}
                summary={tool.summary}
                bullets={tool.bullets.slice(0, 3)}
                tone={tool.tone}
                testid={`features-tool-${tool.id}`}
              />
            </Link>
          ))}
        </div>
      </Section>

      <Section>
        <SectionHeader eyebrow="School management" title="The School ERP" subtitle="Modules that schools actually run on — designed by Indian operations heads." />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {ERP_MODULES.map((m) => (
            <Link key={m.id} to="/school-erp" className="block">
              <FeatureCard icon={m.icon} name={m.name} bullets={m.points} tone={m.tone} testid={`features-erp-${m.id}`} />
            </Link>
          ))}
        </div>
      </Section>

      <CTAStrip
        title="See it in your classroom."
        subtitle="Free starter tier. No credit card. All features visible."
        primary={{ label: 'Sign up free', href: '/signup' }}
        secondary={{ label: 'Talk to Founder', wa: 'Hi Founder! I want to see ActanonEdu in my classroom.' }}
        testid="features-final-cta"
      />
    </MarketingLayout>
  );
}
